import React, { ReactElement } from "react";

import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";

import IconSelector from "../images/IconSelector";

const WebAppBadge = ({ version, count }: { version: string; count: number }): ReactElement => {
 const formatPreRender = (): string => {
  if (version.includes("php")) {
   return "php";
  } else if (version.includes("tomcat")) {
   return "tomcat";
  } else if (version.includes("odoo")) {
   return "odoo";
  } else if (version.includes("nodejs")) {
   return "nodejs";
  } else if (version.includes("litespeed")) {
   return "litespeed";
  } else if (version.includes("apache")) {
   return "apache";
  } else if (version.includes("nginx")) {
   return "nginx";
  } else {
   return version;
  }
 };

 const RenderIcon = (): ReactElement => {
  const framework = formatPreRender();

  switch (framework) {
   case "react":
    return <IconSelector icon="ReactIcon" props={{ fontSize: "small" }} />;
   case "vue":
    return <IconSelector icon="VueIcon" props={{ fontSize: "small" }} />;
   case "wordpress":
    return <IconSelector icon="WordpressIcon" props={{ fontSize: "small" }} />;
   case "owncloud":
    return <IconSelector icon="OwncloudIcon" props={{ fontSize: "small" }} />;
   case "prestashop":
    return <IconSelector icon="PrestashopIcon" props={{ fontSize: "small" }} />;
   case "joomla":
    return <IconSelector icon="JoomlaIcon" props={{ fontSize: "small" }} />;
   case "easyappointments":
    return (
     <IconSelector icon="AppointmentsIcon" props={{ color: "kxOrange", fontSize: "small" }} />
    );
   case "litespeed":
    return <IconSelector icon="LitespeedIcon" props={{ fontSize: "small" }} />;
   case "php":
    return <IconSelector icon="PhpIcon" props={{ fontSize: "small" }} />;
   case "odoo":
    return <IconSelector icon="OdooIcon" props={{ fontSize: "small" }} />;
   case "tomcat":
    return <IconSelector icon="TomcatIcon" props={{ fontSize: "small" }} />;
   case "nodejs":
    return <IconSelector icon="NodejsIcon" props={{ fontSize: "small" }} />;
   case "apache":
    return (
     <img
      width={20}
      height={20}
      src={`${process.env.PUBLIC_URL}/svg/providers/apache2.svg`}
      alt="provider"
     />
    );
   case "nginx":
    return (
     <img
      width={20}
      height={20}
      src={`${process.env.PUBLIC_URL}/svg/providers/nginx.svg`}
      alt="provider"
     />
    );
   default:
    return <></>;
  }
 };

 const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
   right: -3,
   top: 13,
   border: `3px solid ${theme.palette.background.paper}`,
   padding: "0 2px"
  }
 }));

 return (
  <StyledBadge badgeContent={count} color="primary">
   <RenderIcon />
  </StyledBadge>
 );
};

export default WebAppBadge;
